import {LOADING, UNSET} from 'constants/reduxStatuses'
import {createSelector} from 'reselect'
import type {RootState} from 'services/store'

export const rootCompsSelector = (state: RootState) => state.comps

export const compsDataSelector = createSelector([rootCompsSelector], compsData => compsData.data)
export const compsSubjectPidSelector = createSelector(
  [compsDataSelector],
  compsData => compsData.subjectPid
)
export const compsListSelector = createSelector([compsDataSelector], compsData => compsData.comps)

export const compsStatusSelector = createSelector(
  [rootCompsSelector],
  compsData => compsData.status
)
export const compsStatusLoadingSelector = createSelector(
  [compsStatusSelector],
  status => status === LOADING || status === UNSET
)

export const compsErrorSelector = createSelector([rootCompsSelector], compsData => compsData.error)
